"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useFocus2 = _interopRequireDefault(require("./useFocus"));

var _Button = require("../components/Button/Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useActionBar = function useActionBar(skipTitle, actionBarTitle) {
  if (skipTitle === void 0) {
    skipTitle = 'Skip to action bar';
  }

  if (actionBarTitle === void 0) {
    actionBarTitle = 'Action bar';
  }

  var _useFocus = (0, _useFocus2.default)(),
      actionBarRef = _useFocus[0],
      setFocus = _useFocus[1];

  var ActionBarCTA = function ActionBarCTA() {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: "show-on-focus skip-link",
      displayAsLink: true,
      onClick: setFocus
    }, skipTitle);
  };

  var ActionBar = function ActionBar(props) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-form-actions",
      ref: actionBarRef,
      tabIndex: "0",
      "aria-label": actionBarTitle
    }, props.children);
  };

  return {
    ActionBar: ActionBar,
    ActionBarCTA: ActionBarCTA,
    setFocus: setFocus
  };
};

var _default = useActionBar;
exports.default = _default;